// executiveDashboard module actions.js
import utils from '@/utils/utils.js';

export default {
  async fetchTrademarksAndProducts({ commit })  {
   // commit('setLoading', true);
    const response = await utils.utility.fetch('api/Executive/GetExecutiveFilters', 'GET', null, null);
    
    commit('setBrands', response.data.trademarks);
    commit('setProducts', response.data.products);
    commit('setError', null);
  },
  async fetchExecutiveSummaries({ commit },payload) {


    let searchFilter = {
      products: payload?.products ?? [],
      trademarks: payload?.trademarks ?? [],
      Criteria: payload?.Criteria.toString() ?? "1"
    };
    if (payload?.StartDate && typeof payload.StartDate === 'string' && payload.StartDate.length > 0) {
      searchFilter.StartDate = payload.StartDate;
    }
    if (payload?.EndDate && typeof payload.EndDate === 'string' && payload.EndDate.length > 0) {
      searchFilter.EndDate = payload.EndDate;
    }

     try {

      const queryString = utils.utility.checkQueryParams(searchFilter).toString();

      const response = await utils.utility.fetch(`api/Executive/GetExecutiveDataList?${queryString.toString()}`, 'GET', null, null);


      const formattedData = response.data.summaries.map(item => ({
        id: item.id,
        brandName: item.brandName,
        mediaUrl:item.mediaUrl,


        writerCount: item.singleWriterCount,
        totalContent: item.totalContent,
        sentiments: item.sentiments.map(sentiment => ({
          label: sentiment.title,
          value: sentiment.rate
        })),
        topUnits: item.units.map(unit => ({
          name: unit.title,
          examples: unit.examples
        })),
        logoUrl: item.mediaUrl || 'https://via.placeholder.com/50'
      }));

      commit('setExecutiveSummaries', formattedData);
      commit('setError', null);
    } catch (error) {
      commit('setError', error.message || 'Bir hata oluştu');
    } finally {
      commit('setLoading', false);
    }
  }
}
